import React from 'react';

import { useNavigate } from 'react-router-dom';

import backIcon from '@/assets/icons/back.svg';

interface MobileAppBarProps {
  title: string | React.ReactNode;
  onBack?: () => void;
  onRightIconClick?: () => void;
  onRightTwoIconClick?: () => void;
  rightIcon?: string | React.ReactNode;
  rightTwoIcon?: string | React.ReactNode;
  variant?: string;
  className?: string;
  showLeftBackButton?: boolean;
  rightIconClassName?: string;
}

const MobileAppBar: React.FC<MobileAppBarProps> = ({
  title = '',
  onBack,
  onRightIconClick,
  onRightTwoIconClick,
  rightIcon,
  rightTwoIcon,
  variant = 'default',
  className,
  showLeftBackButton = false,
  rightIconClassName = ''
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    // navigate back
    navigate(-1);
  };

  return (
    <header
      className={`z-20 flex items-center justify-between sticky top-0 left-0 bg-white px-5 py-3 h-[56px] md:hidden ${variant === 'primary' ? 'border-b' : ''} ${className}`}
    >
      <div className="flex items-center gap-2">
        {showLeftBackButton && (
          <button onClick={handleBack} className="text-foreground flex items-center gap-1">
            {' '}
            <img src={backIcon} alt="back-icon" />
          </button>
        )}
        {variant === 'default' ? (
          <button onClick={handleBack} className="text-foreground flex items-center gap-1">
            {' '}
            <img src={backIcon} alt="back-icon" /> <span className="text-xs font-medium">{title}</span>
          </button>
        ) : (
          <p className="text-primary text-[28px] font-bold uppercase">{title}</p>
        )}
      </div>

      <div className="flex items-center gap-[1.5rem]">
        {onRightIconClick && (
          <button
            onClick={() => {
              if (onRightIconClick) {
                onRightIconClick();
              }
            }}
            className="text-foreground flex items-center gap-1"
          >
            {' '}
            {typeof rightIcon === 'string' ? (
              <img className={rightIconClassName} src={rightIcon} alt="icon" />
            ) : (
              rightIcon
            )}
          </button>
        )}
        {onRightTwoIconClick && (
          <button
            onClick={() => {
              if (onRightTwoIconClick) {
                onRightTwoIconClick();
              }
            }}
            className="text-foreground flex items-center gap-1"
          >
            {' '}
            {typeof rightTwoIcon === 'string' ? (
              <img className={rightIconClassName} src={rightTwoIcon} alt="icon" />
            ) : (
              rightTwoIcon
            )}
          </button>
        )}
      </div>
    </header>
  );
};

export default MobileAppBar;
